import React from 'react'
import { Dialog, styled } from '@mui/material'
import { CloseButton } from './ImageGallery/CloseButton'

const BlackDialog = styled(Dialog)(({ theme }) => ({
  backgroundColor: '#000',
  '& iframe': {
    width: '100%',
    height: '100%',
    border: 'none',
  },
}))

export const Tour3dModal = (props: {
  onClose: () => void
  url: string
}): JSX.Element => {
  return (
    <BlackDialog fullScreen fullWidth open={true} onClose={props.onClose}>
      <CloseButton onClose={props.onClose} />
      <iframe src={props.url} title='3d tour' />
    </BlackDialog>
  )
}
